import { render } from "./Help.vue?vue&type=template&id=9d0d0b7e&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=9d0d0b7e&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d0d0b7e"]])

export default __exports__